<style lang="scss" scoped>
    .content {
        background-color: #fff;
        min-height: calc(100vh - 84px);
        font-size: 12px;
        padding-top: 20px;
    }

    .title-text {
        color: #02a7f0;
    }

    .tips-info{
        width: 850px;
        margin: 50px auto 0;
    }
    .tip-text {
        letter-spacing: 1px;
    }

    .tip-img {
        max-width: 280px;
    }
</style>

<template>
    <Layout>
        <div class="content">
            <section class="app-main pt50">
                <transition name="fade-transform" mode="out-in">
                    <div class="pt40 pb40" style="background-color: #fff;">
                        <div class="tips-info clear-both ">
                            <div class="img-info fl">
                                <img src="@/assets/img/401.gif" class="tip-img" alt="">
                            </div>
                            <div class="page-info fl mt60 font14px ml30">
                                <h3 class="title-text mb20 text-color-error" style="font-size: 18px;">
                                    <i class="el-icon-warning-outline text-bold" style="font-size: 24px;vertical-align: middle;"></i>
                                    <span class="tip-text pl10">页面不存在</span>
                                </h3>
                                <h4 class="mb10">我们似乎无法找到您要的页面...</h4>
                                <p class="mt60">
                                    <el-button type="primary" @click="toHomePage">回到首页</el-button>
                                </p>
                            </div>
                        </div>
                    </div>
                </transition>
            </section>
        </div>
    </Layout>

</template>

<script>
    import Layout from '@/layout/index.vue';

    export default {
        components:{
            Layout,
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {
            toHomePage(){
                this.$router.push('home');
            }
        }
    }
</script>
